const React = require("react");
const PT = require("prop-types");
const createReactClass = require("create-react-class");

const styles = require("./styles/SelectCSV.css");

module.exports = createReactClass({
	displayName: "SelectCSV",

	propTypes: {
		for: PT.string.isRequired,
		onSelected: PT.func.isRequired,
		fileInfo: PT.object,
		hasError: PT.bool,
	},

	onChange: function(evt) {
		evt.preventDefault();
		evt.stopPropagation();

		const files = evt.target.files;
		if (files && files.length) {
			this.onCSVSelected(files[0]);
		}
	},

	componentDidMount: function() {
		this.fileReader = new FileReader();
		this.fileReader.addEventListener("load", () => this.onFileRead());
	},

	onFileRead: function() {
		const {onSelected} = this.props;
		onSelected(this.file, this.fileReader.result);
	},

	getSelectedFileName: function() {
		const {fileInfo} = this.props;
		return fileInfo ? fileInfo.name : null;
	},

	onCSVSelected: function(file) {
		this.file = file;
		this.fileReader.readAsText(file);
	},

	// This is to make the input fire the onChange event
	// again when a file is selected if the file is the
	// same as the one previously selected (even if the file
	// has changed since it was last selected)
	clearInput: function() {
		if (this.input) {
			this.input.value = null;
		}
	},

	render: function() {
		return (
			<div className={styles.input}>
				<div className={styles.chosenFile}>
					<div className={styles.fileName}>{this.getSelectedFileName()}</div>
				</div>
				<input
					className={styles.fileInput}
					id={`file-${this.props.for}`}
					type={"file"}
					accept={".csv"}
					onChange={this.onChange}
					ref={i => (this.input = i)}
				/>
				<label htmlFor={`file-${this.props.for}`} onClick={this.clearInput}>
					Choose File
				</label>
			</div>
		);
	},
});
